/*****************************************************/
/*This file contains actions taken when back button is
/*clicked. Backlogs are created in BackSystems.js
/*****************************************************/
export function onUndoButtonClicked(Scene,UndoBtn)
{
    ////console.log(`This is awesome ${Scene.CurrentTabName}`);
    if(Scene.BackLog.length > 0)
    {
        Scene.AudioChan.Chan4.play('undo');
        UndoBtn.disableInteractive();
        Scene.addTween(UndoBtn,200,{scale:.798,yoyo:true},Phaser.Math.Easing.Linear,()=>
        {
            UndoBtn.setInteractive();
        });
        
        const UndoAction = Scene.BackLog[Scene.BackLog.length-1];

        //console.log(UndoAction);

        switch(UndoAction.Operation)
        {
            case "Created":
                _undoCreate(UndoAction);
                break;
            case "Moved":
                _undoMoved(UndoAction);
                break;
            case "Swapped":
                _undoSwapped(UndoAction)
                break;
            default:
                break;
        }
        Scene.BackLog.pop();
    }
}

function _undoCreate(UndoAction)
{
    if(UndoAction.AssetType != 'Chain')
    {
        UndoAction.GameObject.destroy();
    }
    else
    {
        UndoAction.GameObject.forEach(element => {
            element.destroy();
        });
    }
}

function _undoMoved(UndoAction)
{
    //console.log(UndoAction);
    UndoAction.GameObject.setPosition(UndoAction.Data.x,UndoAction.Data.y);
}

function _undoSwapped(UndoAction)
{
    //console.log(UndoAction);
    if(UndoAction.AssetType === "TreeTop")
    {
        UndoAction.GameObject.setFrame(UndoAction.OperationData.PreviousFrameName);
        if(UndoAction.OperationData.Tint)
        {
            UndoAction.GameObject.setTint(UndoAction.OperationData.Tint);
        }
        else
        {
            UndoAction.GameObject.clearTint();
        }
    }
    else
    {
        let Tree = UndoAction.GameObject;
        let TreeStroke = UndoAction.GameObject.getData('Stroke');

        Tree.setFrame(UndoAction.OperationData.PreviousFrameName);
        TreeStroke.setFrame(UndoAction.OperationData.PreviousFrameName.replace('BG','Strk'));

        Tree.setTint(UndoAction.OperationData.TintBG);
        TreeStroke.setTint(UndoAction.OperationData.TintStrk);
    }
}